import React from 'react';
import type File from '../../interfaces/File';

import { formatFileSize } from '../../services/utils';

interface FilesTableFileSizeCellProps {
  file: File;
}

const FilesTableFileSizeCell: React.FC<FilesTableFileSizeCellProps> = ({ file }) => {
  return <span>{file.fileExtension ? formatFileSize(file.fileSize) : null} </span>;
};

export default FilesTableFileSizeCell;
